import SectionHeading from "./SectionHeading";
import { formats } from "@/mocks/doujinshi";

export default function FormatCategories() {
  return (
    <section id="formats" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="内容格式"
        title="按格式分类，整本打包一次看全"
        desc="同人志内容按漫画本、插画画集、四格漫画、网络条漫和短篇合集整理，每一类都打包成完整合集，点击即可查看全部内容。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {formats.map((f) => (
          <a
            key={f.id}
            href="#trending"
            className="group flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-200"
          >
            <span className="grid h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={f.icon}></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{f.name}</h3>
            <span className="mt-0.5 text-xs tracking-wide text-foreground-400">{f.en}</span>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-secondary-700">
              <i className="ri-stack-fill"></i>
              {f.count.toLocaleString()} 部打包作品
              <i className="ri-arrow-right-line ml-1 transition-transform group-hover:translate-x-1"></i>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}